import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { OutlinedInput } from "@mui/material";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import '../css/admin.css'

const AdminEvent = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page
    const [sortConfig, setSortConfig] = useState({key:null, direction:"asc"});
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      fetchData();
    }, []);
  
    const fetchData = () => {
      axios
        .get(`https://denticadentalstudio.com/webapp/api/event`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        })
        .then((res) => {
          // console.log(res.data.data.event);
          setData(res.data.data.event);
          setFilteredData(res.data.data.event);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        })
    };
  
    const handleDelete = (id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(
              `https://denticadentalstudio.com/webapp/api/event/delete`,
              { id },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${Cookies.get("token")}`,
                },
              }
            )
            .then((res) => {
              // console.log(res.data);
              setData(data.filter((item) => item.id !== id));
              setFilteredData(filteredData.filter((item) => item.id !== id));
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Data Deleted Successfully!",
                showConfirmButton: false,
                timer: 1000,
              });
            })
            .catch((err) => {
              console.log(err);
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Error !",
                showConfirmButton: false,
                timer: 1000,
              });
            });
        }
      });
    };
    const handleSort = (key) => {
      // If the same column is clicked again, toggle the direction
      const direction =
        sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
      setSortConfig({ key, direction });
    };
  
    const sortedData = React.useMemo(()=>{
      let sortableData = [...data];
      if (sortConfig.key !== null){
        sortableData.sort((a,b)=>{
          if (a[sortConfig.key] < b[sortConfig.key]){
            return sortConfig.direction === "asc" ? -1:1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]){
            return sortConfig.direction === "asc"? 1:-1;
          }
          return 0;
        })
      }
      return sortableData;
    }, [data, sortConfig])
  
    const getSortIcon = (key) => {
      if (sortConfig.key === key) {
        if (sortConfig.direction === "asc") {
          return <FaSortUp />;
        } else if (sortConfig.direction === "desc") {
          return <FaSortDown />;
        }
      }
      return <FaSort />;
    };
    const handleSearch = (query) => {
      setSearchQuery(query);
      const filtered = data.filter(
        (item) => item.category_id && item.category_id.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredData(filtered);
      setCurrentPage(1);
    };
  
    const handleRowsPerPageChange = (e) => {
      setRowsPerPage(parseInt(e.target.value));
      setCurrentPage(1); // Reset current page when rows per page changes
    };
  
    const itemsPerPage = rowsPerPage;
    const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  
    // pagination buttons start
    const paginationButtons = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === currentPage ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        paginationButtons.push(
          <li
            key={i}
            className={`page-item ${currentPage === i ? "active" : ""}`}
          >
            <button className="page-link" onClick={() => setCurrentPage(i)}>
              {i}
            </button>
          </li>
        );
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        paginationButtons.push(
          <li key={i} className={"page-item ellipsis"}>
            <span className="ellipsis">...</span>
          </li>
        );
      }
    }
  
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(currentPage * itemsPerPage, filteredData.length);
    const displayedData = sortedData.slice(startIndex, endIndex);
  return (
    <div>
      {loading && (
        <div className="preloaderContainer">
          <div className="preloaderBg">
            <div className="preloader"></div>
            <div className="preloader2"></div>
          </div>
        </div>
      )}
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6 text-left">
                  <h1>Event</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <Link to="/admin/home">Home</Link>
                    </li>
                    <li
                      className="breadcrumb-item active"
                      style={{ color: "#ca629d" }}
                    >
                      Event
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div
                      className="card-header text-light"
                      style={{
                        textAlign: "end",
                        backgroundColor: "rgb(37, 111, 152)",
                      }}
                    >
                      <h3 className="card-title">Event List</h3>
                      <div>
                        <Link
                          to="/admin/event/add"
                          className="form-dlt-btn"
                          style={{
                            border: "0",
                            backgroundColor: "#ca629d",
                            color: "white",
                            padding: "5px 10px",
                            borderRadius: "5px",
                          }}
                        >
                          Add
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex" style={{ alignItems: "center" }}>
                      <div className="page-item">
                        <span style={{ margin: "0 20px", fontWeight: "600" }}>
                          Rows Per Page :
                        </span>
                        <input
                          type="number"
                          value={rowsPerPage}
                          onChange={handleRowsPerPageChange}
                          style={{
                            width: "70px",
                            marginRight: "5px",
                          }}
                        />
                      </div>
                      <div className="search-bar">
                        <OutlinedInput
                          type="text"
                          variant="outlined"
                          placeholder="Search.."
                          value={searchQuery}
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{ height: "30px", margin: "10px 0" }}
                        />
                      </div>
                    </div>
                    <div className="table-container">
                      <div className="card-body">
                        <table
                          id="example2"
                          className="table table-bordered table-hover"
                        >
                          <thead>
                            <tr>
                            <th style={{cursor:"pointer"}} onClick={()=>handleSort("id")}>
                              SL {getSortIcon("id")}
                            </th>
                            <th style={{cursor:"pointer"}} onClick={()=>handleSort("name")}>
                              Category {getSortIcon("category")}
                            </th>
                              <th>Image</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {displayedData.map((ele, index) => (
                              <tr key={index}>
                                <td>{startIndex + index + 1}</td>
                                <td>{ele.slug}</td>
                                <td width={"200px"} height={"100px"}>
                                  <img
                                    src={ele.image}
                                    alt=""
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </td>
                                <td className="align-middle text-center">
                                  <Link
                                    to={`/admin/event/edit/${ele.id}`}
                                    className="form-btn"
                                    style={{
                                      border: "1px solid #17a2b8",
                                      backgroundColor: "white",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <span style={{ color: "#17a2b8" }}>
                                      <FiEdit />
                                    </span>
                                  </Link>
                                  <button
                                    onClick={() => handleDelete(ele.id)}
                                    className="form-btn-dlt"
                                    style={{
                                      border: "1px solid red",
                                      backgroundColor: "white",
                                      padding: "1px 5px",
                                      marginLeft:"10px"
                                    }}
                                  >
                                    <span style={{ color: "red" }}>
                                      <MdDelete />
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row" style={{ display: "flex" }}>
                      <div className="col-sm-12 col-md-5">
                        <div
                          className="dataTables_info"
                          id="example1_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing {startIndex + 1} to {endIndex} of{" "}
                          {filteredData.length} entries
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="example1_paginate"
                        >
                          <ul className="pagination">
                            <li
                              className={`page-item previous ${
                                currentPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage === 1}
                              >
                                Previous
                              </button>
                            </li>
                            {paginationButtons}
                            <li
                              className={`page-item next ${
                                currentPage === totalPages ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={currentPage === totalPages}
                              >
                                Next
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default AdminEvent